import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {DashboardOPEEnum} from "./DashboardOPEEnum";

export enum ShareTargetStatusEnum {
  COPIED = 'COPIED',
  SKIPPED_NOT_AUTHORIZED = 'SKIPPED_NOT_AUTHORIZED',
  SKIPPED_NO_VISIBLE_METRICS = 'SKIPPED_NO_VISIBLE_METRICS',
  // Solo validateShareDraft lo restituisce: shareDashboard, a copia fatta, torna COPIED
  COPIED_PARTIALLY = 'COPIED_PARTIALLY'
}

export class ShareTargetResultDTO {
  userId!: number;
  username?: string;
  status!: ShareTargetStatusEnum;
  newDashboardId?: number;
  copiedWidgetCount!: number;
  skippedWidgetCount!: number;
}

class O {
  results!: ShareTargetResultDTO[];
  warningMessage?: string;
}

/**
 * I Inner Class
 */
class I {
  dashboardId!: number;
  name!: string;
  targetUserIds!: number[];
}

/**
 * ShareDashboardCB class
 */
export class ShareDashboardCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(DashboardOPEEnum.ShareDashboard);
    this.i = new I();
    this.o = new O();
  }

}
